
import { Paper } from '@mui/material'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'

const StyledPaper = styled(Paper)(({ theme, align }) => ({
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: align,
    gap: theme.spacing(3)
}))

/**
 * @description Renders a styled Paper component.
 * 
 * @author Maria Eduarda Franke
 * @param {ReactNode} props.children - The content to be rendered inside the Paper component.
 * @returns {ReactElement} The rendered Paper component.
 */
const MyPaper = ({ children, alignItems = 'center', ...props }) => {
    return (
        <StyledPaper elevation={0} align={alignItems} {...props}>
            {children}
        </StyledPaper>
    )
}

MyPaper.propTypes = {
    children: PropTypes.node.isRequired,
    alignItems: PropTypes.oneOf(['center', 'flex-start', 'flex-end'])
}

export { MyPaper as Paper }
